import {
  AccordionSummary as MUIAccordionSummary,
  type AccordionSummaryProps,
} from '@mui/material';

export { type AccordionSummaryProps } from '@mui/material';

export function AccordionSummary(props: AccordionSummaryProps) {
  return <MUIAccordionSummary {...props} />;
}
